export default "__VITE_ASSET__777d2315__"